import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ACTIVITY_EVENTS } from "../context/AuthContext";

export const FINANCE_IDLE_MS = 5 * 60 * 1000;

/** Telas financeiras sensíveis: 5 min sem interação → volta ao Dashboard (oculta os dados) sem encerrar a sessão. Vale para todos os perfis. */
export const FinanceIdleGuard = ({ children, label = "Tela financeira" }) => {
  const navigate = useNavigate();
  const lastRef = useRef(Date.now());
  useEffect(() => {
    const bump = () => { lastRef.current = Date.now(); };
    ACTIVITY_EVENTS.forEach((ev) => window.addEventListener(ev, bump, { passive: true }));
    const check = () => {
      if (Date.now() - lastRef.current >= FINANCE_IDLE_MS) {
        toast.info(`${label} fechada após 5 minutos sem atividade — por segurança os dados foram ocultados.`, { duration: 8000 });
        navigate("/", { replace: true });
      }
    };
    const timer = setInterval(check, 5000);
    document.addEventListener("visibilitychange", check);
    return () => {
      ACTIVITY_EVENTS.forEach((ev) => window.removeEventListener(ev, bump));
      document.removeEventListener("visibilitychange", check);
      clearInterval(timer);
    };
  }, [navigate, label]);
  return children;
};
